module.exports = __webpack_public_path__ + "img/item4.a4513379.png";